var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CommonLayout',{attrs:{"header":"floristHeader","footer":"floristFooter"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center align-items-center mh-100vh"},[_c('div',{staticClass:"col-md-8 text-center"},[_c('h2',[_vm._v("ミーティング情報が取得できませんでした。"),_c('br'),_vm._v("もう一度ログインしてください。")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e398028","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FloristMeetingError.vue
// module id = null
// module chunks = 